import { render, staticRenderFns } from "./PackageManagementEdit.vue?vue&type=template&id=107dcc62&scoped=true"
import script from "./PackageManagementEdit.vue?vue&type=script&lang=js"
export * from "./PackageManagementEdit.vue?vue&type=script&lang=js"
import style0 from "./PackageManagementEdit.vue?vue&type=style&index=0&id=107dcc62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107dcc62",
  null
  
)

export default component.exports